import { QuestionnaireGroup, QuestionnaireQuestionAnswer } from 'src/@types';

const calculateResults = (
  data: Record<string, string>,
  questionnaire: QuestionnaireGroup
): [number, QuestionnaireQuestionAnswer[]] => {
  let totalScore = 0;
  const answersGiven: QuestionnaireQuestionAnswer[] = [];

  for (const questionId in data) {
    const answerId = data[questionId];
    const question = questionnaire.questions.find((q) => q.id === questionId);

    if (question) {
      const answer = question.answers.find((a) => a.id === answerId);

      if (answer) {
        totalScore += answer.score;
        answersGiven.push(answer);
      }
    }
  }

  return [totalScore, answersGiven];
};

export { calculateResults };
